// src/components/ErrorBoundary.js

import React, { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Error Boundary Caught an error", error, info);
  }

  render() {
    if (this.state.hasError) {
      return <div>Component failed to load</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
